/*
 * File: updateAddress.ts
 * Project: meki
 * File Created: Thursday, 25th February 2021 11:40:34 am
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Thursday, 24th February 2022 10:43:52 am
 * Modified By: Joaquín Muñoz (joaquin@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';
import { Address, AddressMetadata } from '@interfaces';
import { AddressBaseFragment } from '../fragments';

export const UpdateAddressMutation = () => gql`
  mutation updateAddress($params: UpdateAddressParams!) {
    updateAddress(params: $params) {
      ...AddressBase
    }
  }
  ${AddressBaseFragment}
`;

export type UpdateAddressMutationParams = ResolverParams<{
  uuid: string;
  region: string;
  commune: string;
  street?: string;
  streetNumber?: string;
  apartment?: string;
  details?: string;
  name?: string;
  metadata?: AddressMetadata;
}>;

export type UpdateAddressMutationResponse = { updateAddress: Address };
